import {i18n} from '@/plugins/i18n'
import StatusColumn from "../components/status-column";

const statusTemplate = (row, index, datatable) => {
    let template = new StatusColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}
export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        width: 40,
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'customer_code',
        title: i18n.t('pos.customer_code'),
        sortable: false,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'customer_name',
        title: i18n.t('pos.customer_name'),
        sortable: false,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'visitor',
        title: i18n.t('pos.visitor'),
        sortable: false,
        template: (row) => {
            return '<a href="/users/' + row.visitor_id + '/details">'+row.visitor+'</a>'
        },
        width: 60,
        textAlign: 'center',
    }  ,
    {
        field: 'shop_name',
        title: i18n.t('pos.shop_name'),
        sortable: false,
        width: 60,
        textAlign: 'center',
    }  ,
    {
        field: 'psp',
        title: i18n.t('label.psp'),
        textAlign: 'center',
        template: (row) => {
            switch(row.psp) {
                case 'MELLAT':
                    return '<div><img src="/assets/media/psp/mellat.png" width="32" height="32"></div>';
                case 'PARSIAN':
                    return '<div><img src="/assets/media/psp/parsian.svg" width="32" height="32"></div>';
                case 'PASARGAD':
                    return '<div><img src="/assets/media/psp/pasargad.svg" width="32" height="32"></div>';
                case 'SAMAN':
                    return '<div><img src="/assets/media/psp/saman.svg" width="32" height="32"></div>';
                case 'NOVIN':
                    return '<div><img src="/assets/media/psp/novin.svg" width="32" height="32"></div>';
                case 'SEPEHR':
                    return '<div><img src="/assets/media/psp/sepehr.png" width="32" height="32"></div>';
                case 'IRANKISH':
                    return '<div><img src="/assets/media/psp/irankish.png" width="32" height="32"></div>';
            }

            return '<span>' + row.psp + '</span>';
        },
    },
    {
        field: 'terminal_number',
        title: i18n.t('label.terminal_number'),
        sortable: false,
        width: 60,
        textAlign: 'center',
    },
    {
        field: 'terminal_id',
        title: i18n.t('label.terminal_id'),
        sortable: false,
        width: 60,
        textAlign: 'center',
    },
    {
        field: 'followup_code',
        title: i18n.t('pos.followup_code'),
        sortable: false,
        width: 60,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('pos.created_at'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    }
]